import gql from 'graphql-tag';

export const GET_DOCUMENTS_WITH_STATUS = gql`
  query getDocumentsWithStatus($coachId: Int!, $status: String!) {
    documents(
      where: {
        creator: {
          v_student: {
            _and: [
              { _or: [{ lc_id: { _eq: $coachId } }, { hc_id: { _eq: $coachId } }] }
              {
                _or: [
                  { is_trial: { _neq: true } }
                  { is_trial: { _is_null: true } }
                ]
              }
            ]
          }
        }
        status: { _eq: $status }
      }
    ) {
      id
      created_by
      filename
      creator {
        name
      }
      university {
        id
        university_name
      }
      url
    }
  }
`;
